const Tags = ({ text }) => {
  return <span className="tag">{text}</span>;
};

export default Tags;
